import React from "react";

import Article from "components/Templates/Article";
import allHeaders from "components/Properties/AllHeaders";
import allHashTags from "components/Properties/AllHashTags";

const header = {
  ...allHeaders["otelLangfuseConsole"],
  ...allHashTags,
  channel: "34"
};

const data = [
  {
    type: "subheading",
    name: "introduction",
    title: "Introduction"
  },
  {
    type: "text",
    content:
      "Open Telemetry or OTEL, for short, is an industry standard generic instrumentation for traces, metrics, logs etc. Langfuse extends OTEL to provide observability layer for LLMs."
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />There are 3 different entities that you should know about when you are monitoring your LLMs."
  },
  {
    type: "subheading",
    name: "traceability",
    title: "1. Traceability —"
  },
  {
    type: "text",
    content:
      "OTEL is used to capture —" +
      "<ul><li>Traces</li><li>Spans</li></ul>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Langfuse is used to capture LLM specific metadata —" +
      "<ul><li>Token counts</li><li>Model parameters</li><li>Output</li><li>Scores</li></ul>"
  },
  {
    type: "subheading",
    name: "observability",
    title: "2. Observability —"
  },
  {
    type: "text",
    content:
      "OTEL is used to send —" +
      "<ul><li>Metrics — Prometheus, Grafana</li><li>Logs — ELK/Datadog</li></ul>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Langfuse is used to show —" +
      "<ul><li>Prompt level performance analysis</li><li>A/B test comparisons</li><li>Quality metrics (hallucination rate, relevance scores)</li></ul>"
  },
  {
    type: "subheading",
    name: "observability",
    title: "3. Exporters —"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />You will need this to visualize your traces, spans, metrics, logs etc in a nice graphical user interface. Exports sends these to tools like Jaeger, Langfuse cloud or to a console as a JSON."
  },  
  {
    type: "googleAd",
    position: "middle1"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />In this article, we will try to create all 3 kinds of exporters and see how we can trace and observe the metrics on dashboards."
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Softwares needed:" +
      "<ul><li>Python</li><li>Ollama — to run LLM locally</li><li>Docker Desktop — to run Jaeger locally</li><li>Langfuse account — to export to Langfuse cloud, its free with some limitations</li></ul>"
  },
  {
    type: "info",
    content: [
      {
        type: "text",
        content:
          "For each exporter type — Console, Langfuse and Jaeger, we will create two files, one for inference and other for exporting the traces, spans, metrics etc."
      }
    ]
  }, 
  {
    type: "subheading",
    name: "otel-console-exporter",
    title: "Console Exporter"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Step 1: Create inference file</h3> " +
      "Create a python file, <i>console_langchain_inference.py</i> as shown,"
  },
  {
    type: "gist",
    content: "65a45aab648f630811d51b746d73c89d"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Steps involved<ul><li>Uses langchain to initialize llama3 model running locally</li>" +
      "<li>Create a prompt and call the model</li>" +
      "<li>Uses <code>trace_llm</code> decorator — This is the next file we are going to create</li>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' /><h3>Step 2: Create console exporter file</h3>"+
      "Create a python file, <i>otel_console_exporter.py</i> and copy the below code,"
  },
  {
    type: "gist",
    content: "02272f3cc5dd5089238574c948241cff"
  }, 
  {
    type: "text",
    content:
      "<div class='lineBreak' />Steps involved<ul><li>Create a simple decorator</li>" +
      "<li>Use OTELs console span exporter</li>" +
      "<li>Add the required attributes to show — input, prompt and output</li>"
  },
  {
    type: "info",
    content: [
      {
        type: "text",
        title: "Quick Tip",
        content:
          "To run,<ul><li>1. Start ollama — ollama serve</li><li>2. python3 console_langchain_inference.py</li></ul>"
      }
    ]
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />"
  },  
  {
    type: "gistConsole",
    content: "d09caff80b6c6a92e86d821e30c67123"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Explanation<ul><li>Prompt response is also printed</li>" +
      "<li>The entire trace, span, metrics etc is output as JSON</li>" +
      "<li>You can see the input, output and prompt related attributes</li>"
  },  
  {
    type: "info",
    content: [
      {
        type: "text",
        title: "Quick Tip",
        content:
          "<i>Traceability = identifiers + timing + relationships (trace_id, span_id, parent_id, start/end, links, events).</i>" +
          "<br/>" +
          "<i>Observability = semantic attributes + metrics + status (function name, args, response length, status_code, SDK metadata).</i>"
      }
    ]
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Excellent, we can see the trace displayed in the console now, but hold on, is it user friendly ? Not for everyone. This is where we need a nice graphical user interface to visualize the contents of the JSON. But, what is the use of console exporter, then ? Console exporters are especially useful where you have built your own custom visual interface using JSON as input or if you want to send the JSON to any other system for further processing and analysis."
  },
  {
    type: "googleAd",
    position: "middle2"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Lets modify our code to use Langfuse’s observe decorator instead of our custom decorator."
  },
  {
    type: "info",
    content: [
      {
        type: "text",
        content:
          "Custom decorators gives more control to the developer to add custom attributes or enrich the existing attributes."
      }
    ]
  },  
  {
    type: "subheading",
    name: "otel-langfuse-exporter",
    title: "Langfuse Exporter"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Navigate to <MyLink class='homelink' href='https://cloud.langfuse.com/' target='_blank'>cloud.langfuse.com</MyLink>, create an account and create a sample project and keep it ready. Once created, go to “Settings -> API Keys” copy the below to your <i>.env</i> file"
  },
  {
    type: "gist",
    content: "4a46a6cd1b411f523e33507ec0dcc4d6"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Now, modify your <i>console_langfuse_inference.py</i> file, as below"
  },
  {
    type: "gist",
    content: "d66d23685d4482f0471c40734d92980e"
  }, 
  {
    type: "text",
    content:
      "<div class='lineBreak' />Explanation<ul><li>Custom decorator is replaced with Langfuse <i>observe</i> decorator</li>" +
      "<li>dotenv is initialized to make sure our code retrieves the secret key, public key and host url variables from <i>.env</i> file</li>"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />Lets run again with the same command and see the output,"
  },
  {
    type: "gistConsole",
    content: "ed2c2ea75786cdfe938a22a2fc009dc1"
  },   
  {
    type: "text",
    content:
      "<div class='lineBreak' />This time, the output contains only the response of LLM as we are printing it in the code."
  },
  {
    type: "googleAd",
    position: "middle3"
  },  
  {
    type: "text",
    content:
      "<div class='lineBreak' />Navigate to <MyLink class='homelink' href='https://cloud.langfuse.com/' target='_blank'>cloud.langfuse.com</MyLink>, and you will see the trace is exported to Langfuse cloud."
  },  
  {
    type: "image",
    content:
      "https://github.com/learninjavagithub/assets/raw/master/articles/ai/otel_langfuse_exporter_cloud.webp"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />You can trace the request under “Observability -> Tracing”"
  },
  {
    type: "image",
    content:
      "https://github.com/learninjavagithub/assets/raw/master/articles/ai/otel_langfuse_exporter_cloud_trace.webp"
  },
  {
    type: "text",
    content:
      "<div class='lineBreak' />There will be various dashboards created by default, you can explore all under “Dashboards”"
  },
  {
    type: "image",
    content:
      "https://github.com/learninjavagithub/assets/raw/master/articles/ai/otel_langfuse_exporter_cloud_dashboard.webp"
  },
  {
    type: "text",
    content: "<div class='lineBreak' />In my next article, we will create an <i>Jaeger exporter</i> and we will see how we can trace a request end to end, until then, Happy generating!"
  },
  {
    type: "googleAd",
    position: "middle4"
  },
  {
    type: "text",
    content: "<div class='lineBreak' />"
  },
  {
    type: "footnote"
  },
  {
    type: "navLinks",
    previousURL: "/2-ways-to-run-ollama-deepseek-r1-tulu3-locally/",
    previousText: "2 Ways to run Ollama with DeepSeek-R1 or Tulu-3 locally - Using Docker and Directly on Local Machine",
    nextURL: "/how-to-test-deepseek-r1-tulu3-locally-with-openwebui-lmstudio/",
    nextText: "How to test your LLMs locally with GUI tools, Open WebUI and LM Studio"
  }
];

class OTELLangfuseConsole extends React.Component {
  render() {
    return (
      <>
        <Article header={header} data={data} />a
      </>
    );
  }
}

export default OTELLangfuseConsole;
